import { useEffect, useState } from 'react';

import * as St from './Logo.styles';

import { useGetBrandLogoQuery } from '~/api/products-api/productsApiService';
import { PRODUCTS_API_URL } from '~/core/constants/productsApi';
import { useRetailerSettings } from '~/core/hooks/useRetailerSettings';

const FALLBACK_LOGO_SRC = '/public/assets/images/Header/eeWhiteLogoFull.svg';

const Logo = (): JSX.Element => {
  const { retailerSettings } = useRetailerSettings();
  const brandSlug = retailerSettings?.brandSlug?.trim() ?? '';
  const canFetchLogo = Boolean(brandSlug && PRODUCTS_API_URL);

  const { data: brandLogoUrl } = useGetBrandLogoQuery(brandSlug, {
    skip: !canFetchLogo,
  });

  const [imageFailed, setImageFailed] = useState(false);

  useEffect(() => {
    setImageFailed(false);
  }, [brandLogoUrl]);

  const logoSrc =
    !imageFailed && brandLogoUrl ? brandLogoUrl : FALLBACK_LOGO_SRC;

  return (
    <St.Container>
      <St.LogoImage
        src={logoSrc}
        alt="Logo"
        onError={() => setImageFailed(true)}
      />
    </St.Container>
  );
};

export default Logo;
